import React from 'react'
import { connect } from 'react-redux'
import { Link, } from 'react-router-dom'

import Main from '../../Main';



const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const AppatchLayout = props => {
  return (
      <Main {...props}></Main>
  )
}

export default (connect(mapStateToProps)(AppatchLayout))
